import React from 'react'

import { createRoot } from 'react-dom/client'

import * as Sentry from '@sentry/react'

//  please keep this order
//  import 'mailup-web-components/bundle/resources/mailup-web-app/sass/app.scss'
//  TODO fix errori css
import 'mailup-web-components/bundle/css/legacy.css'
//  please keep this order
import 'mailup-web-components/bundle/esm/css/assets.css'
//  please keep this order
import './sass/style.scss'

import App from './App'

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_LIST,
  STORE_KEY_USER,
  storeGet,
} from 'mailup-react-helpers'

const SENTRY_DSN = process.env.SENTRY_DSN
const RELEASE = process.env.RELEASE
const ENV = process.env.APP_ENV
const IS_DEV = process.env.IS_DEV

if (SENTRY_DSN && RELEASE && !IS_DEV) {
  const account = storeGet(STORE_KEY_ACCOUNT)
  const list = storeGet(STORE_KEY_LIST)
  const user = storeGet(STORE_KEY_USER)

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENV,
    release: RELEASE,
    integrations: [new Sentry.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: ENV === 'DEV' || ENV === 'QA' ? 1.0 : 0.01,

    initialScope: (scope) => {
      scope.setExtras({
        IdConsole: account ? parseInt(storeGet(STORE_KEY_ACCOUNT).Id) : 0,
        IdList: list ? parseInt(list.IdList) : 0,
        IdUser: user ? parseInt(user.Id) : 0,
      })
      return scope
    },
  })
}

const container = document.getElementById('app')
const root = createRoot(container)

root.render(<App location={window.location} />)
